<div class="modal-backdrop" *ngIf="isVisible"></div>

<div class="modal-wrapper" *ngIf="isVisible">
  <div class="modal-box">

    <!-- HEADER -->
    <div class="modal-header color_4 color_2">
      <h5 class="modal-title">
        {{ title }}
      </h5>
    </div>

    <!-- BODY -->
    <div class="modal-body">
      <p>
        {{ message }}
      </p>
    </div>

    <!-- FOOTER -->
    <div class="modal-footer">
      <button class="modal-btn" (click)="close()">
        Okay
      </button>
    </div>

  </div>
</div>